const state ={
    PlayerOfMonth: false,
    ParticipantPlayerOfMonth: false,
};
const getters ={
    PlayerOfMonth : () => state.PlayerOfMonth,
    ParticipantPlayerOfMonth : () => state.ParticipantPlayerOfMonth
};
const actions ={
    changePom({commit} , data){
        commit("changePomDailog" , data)
    },
    changeParticipantPom({commit} , data){
        commit("changeParticipantPomDailog" , data)
    }
};
const mutations ={
    changePomDailog(state , data){
        state.PlayerOfMonth = data
    },
    changeParticipantPomDailog(state , data){
        state.ParticipantPlayerOfMonth = data
    },
}












export default {
    state,
    getters,
    actions,
    mutations,
  };
  